import { render, staticRenderFns } from "./UnitMonthlyReport.vue?vue&type=template&id=2c35c454&scoped=true"
import script from "./UnitMonthlyReport.vue?vue&type=script&lang=js"
export * from "./UnitMonthlyReport.vue?vue&type=script&lang=js"
import style0 from "./UnitMonthlyReport.vue?vue&type=style&index=0&id=2c35c454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c35c454",
  null
  
)

export default component.exports